export default __webpack_public_path__ + "static/media/icon--plus.342c32cd.svg";